module.exports = __webpack_public_path__ + "4f3b5dbc0067f11a4493463bfb61fd94.svg";